import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-my-contacts',
  templateUrl: './my-contacts.component.html',
  styleUrls: ['./my-contacts.component.css']
})
export class MyContactsComponent implements OnInit {

  myContacts: any[] = [];
  isLoading = false;
  loadFailed = false;
  id = localStorage.getItem('user_id');
  user_id = parseInt(this.id, 10);

  readonly fallbackAvatar = 'assets/images/avatar.png';

  constructor(private apiService: ApiService, private router: Router) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.apiService.getContact(this.user_id).subscribe(
      (response) => {
        this.myContacts = response.contacts || [];
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching contacts:', error);
        this.loadFailed = true;
        this.isLoading = false;
      }
    );
  }

  sendMessage(id: any) {
    this.router.navigate(['/messages']);
  }

  photo(u: any): string {
    const p = u?.profile_image;
    if (!p || typeof p !== 'string') { return this.fallbackAvatar; }
    if (p.startsWith('data:image') || p.startsWith('http')) { return p; }
    if (p.length < 300 && p.includes('/')) { return p; }
    return 'data:image/jpeg;base64,' + p;
  }

  sub(u: any): string {
    return [u?.job_title, u?.company].filter(Boolean).join(' | ');
  }

  onImgError(e: any) {
    const img = e.target as HTMLImageElement;
    if (img.dataset['fb']) { return; }
    img.dataset['fb'] = '1';
    img.src = this.fallbackAvatar;
  }
}
